module.exports = __webpack_public_path__ + "media/images/help_shop-6c0b66a9743eaf0abb7fb8d8d2004591.png";